<template>
  <ListingBlockLayout title="Podcast Episodes">
    <PodcastEpisodeCardSkeleton v-for="i in numberOfCardsToRender" :key="i" />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import PodcastEpisodeCardSkeleton from '@/app/components/listing/skeleton-loaders/PodcastEpisodeCardSkeleton.vue'

const numberOfCardsToRender = 3
</script>
